import { render } from "./ProductUploadImage.vue?vue&type=template&id=44c83ff1&scoped=true"
import script from "./ProductUploadImage.vue?vue&type=script&lang=js"
export * from "./ProductUploadImage.vue?vue&type=script&lang=js"

import "./ProductUploadImage.vue?vue&type=style&index=0&id=44c83ff1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c83ff1"]])

export default __exports__